import { useCampaign } from '@tm/client-form/src/hooks/useCampaign'
import useI18N from '@tm/client-form/src/hooks/useI18n'
import { useTitle } from '@tm/client-form/src/hooks/useTitle'
import { useEffect } from 'react'
import { ViewProps } from '../types'
import { ThanksView } from './ThanksView'

type ThanksLoaderProps = {
  state: ViewProps['state']
  t: ViewProps['t']
}

export function ThanksLoader({ state, t }: ThanksLoaderProps) {
  const { tt } = useI18N()
  const { thanksPage = {}, lang, enableTextCopy = false } = state
  const title = tt(thanksPage.thanks?.title) || t('thanks.title')
  const text = tt(thanksPage.thanks?.text) || t('thanks.text')
  const thirdPartySources = thanksPage.thanks?.thirdPartyCollect?.sources || []
  const thirdPartyEnabled = thanksPage.thanks?.thirdPartyCollect?.enabled || false
  const autoRedirectEnabled = thanksPage.thanks?.thirdPartyCollect?.autoRedirect || false

  const { resetCampaignState } = useCampaign()

  useEffect(() => {
    if (resetCampaignState && state.features.includes('autoReset')) {
      const timeout = setTimeout(resetCampaignState, 5000)
      return () => {
        clearTimeout(timeout)
      }
    }
  }, [resetCampaignState, state.features])

  useTitle(title)

  return (
    <ThanksView
      title={title}
      text={text}
      review={enableTextCopy ? state.values.comment || state.values.feedback : undefined}
      sources={thirdPartyEnabled ? thirdPartySources : undefined}
      lang={lang}
      autoRedirectEnabled={autoRedirectEnabled}
    />
  )
}
